import { API_TOKEN } from '@/environment'
import {
  type AttensiFetchError,
  createAttensiFetch,
} from '@attensi/v3-client-wip'
import { getAccessToken } from '../activeSession'

export const customFetchMedia = createAttensiFetch({
  getHeaders,
  onError,
})

async function getHeaders() {
  return {
    Accept: 'application/vnd.api+json',
    Authorization: 'Bearer ' + (await getAccessToken()),
    'API-Token': API_TOKEN,
  }
}

function onError(e: AttensiFetchError) {
  console.error(e.cause)
}
